import './AnimatedTargetEmoji.styles.scss';

import React, { FC, useEffect, useMemo, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import { TARGET_EMOJI_ANIMATION_START_DELAY } from '../../../constants';
import { AnimatedTargetEmojiProps } from './AnimatedTargetEmoji.types';

const AnimatedTargetEmoji: FC<AnimatedTargetEmojiProps> = ({
  startPosition,
  endPosition,
  targetEmoji,
}) => {
  const emojiRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setTimeout(() => {
      if (emojiRef.current) {
        emojiRef.current.style.left = `${endPosition.playerX}px`;
        emojiRef.current.style.top = `${endPosition.playerY}px`;
      }
    }, TARGET_EMOJI_ANIMATION_START_DELAY);
  }, [endPosition]);

  const isEnemy = targetEmoji.pid != targetEmoji.targetPid;

  const emojiImage = useMemo(
    () =>
      isEnemy
        ? `/assets/emoji_xpoker/${targetEmoji.text}.png`
        : `/assets/xpoker_self_emoji/${targetEmoji.text}.png`,
    [targetEmoji],
  );

  return (
    <CSSTransition in={true} timeout={500} unmountOnExit>
      <div
        className={`AnimatedTargetEmoji-Component ${
          isEnemy ? 'fly' : 'on-place'
        }`}
        ref={emojiRef}
        style={{
          left: startPosition.playerX,
          top: startPosition.playerY,
        }}
      >
        <img
          width="100px"
          height="100px"
          src={emojiImage}
          alt={`emoji_${targetEmoji.text}`}
        />
      </div>
    </CSSTransition>
  );
};

export default AnimatedTargetEmoji;
